import { DEFAULT_AI_GPT_MODEL } from './aiModels';
import { getDomainAndPort } from '../Utils';

export const BASE_URL = `${getDomainAndPort().protocolDomain}/api/openai/responses`;

async function sendMessageToChatBot(
  content: Array<{
    role: string;
    content: Array<{ type: string; text: string }>;
  }>,
  enableSearch: boolean,
  model: string = DEFAULT_AI_GPT_MODEL
) {
  if (!content || content.length === 0) return '';

  try {
    const bodyPayload = {
      model,
      input: content,
      text: {
        format: { type: 'text' },
        verbosity: 'medium',
      },
      tools: enableSearch
        ? [
            {
              type: 'web_search',
            },
          ]
        : [],
      store: true,
      include: [],
    };

    const messageResponse = await fetch(BASE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bodyPayload),
    });

    if (!messageResponse.ok) {
      throw new Error(`HTTP error! status: ${messageResponse.status}`);
    }

    return await messageResponse.json();
  } catch (error) {
    console.error('Error adding message:', error);
    return null;
  }
}

export default sendMessageToChatBot;
